import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { BRAND_NAME, BRAND_LOGO } from "../constants/content";
import { useCheckoutUrl } from "../lib/useCheckoutUrl";
import { trackInitiateCheckout } from "../lib/trackConversion";

export const SiteHeader = () => {
  const [scrolled, setScrolled] = useState(false);
  const checkoutUrl = useCheckoutUrl();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-white/75 border-b border-black/5 shadow-sm"
          : "bg-transparent"
      }`}
    >
      <nav
        aria-label="Primary"
        className="max-w-7xl mx-auto flex items-center justify-between px-6 md:px-12 py-4"
      >
        <a href="#hero" data-testid="header-logo-link" className="flex items-center gap-3 group">
          <img
            src={BRAND_LOGO}
            alt={`${BRAND_NAME} logo`}
            className="h-9 w-9 rounded-full object-cover ring-1 ring-black/10"
            width="36"
            height="36"
            loading="eager"
          />
          <span className="font-sans font-semibold tracking-[0.15em] text-xs md:text-sm uppercase text-ink">
            {BRAND_NAME}
          </span>
        </a>

        <motion.a
          href={checkoutUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={trackInitiateCheckout}
          data-testid="header-buy-now-button"
          whileTap={{ scale: 0.97 }}
          className="rounded-full bg-gold text-white text-sm font-medium px-5 py-2.5 hover:bg-[#c17588] transition-colors duration-200"
        >
          Buy Now
        </motion.a>
      </nav>
    </header>
  );
};
